import React, { useEffect } from "react";
import { useState } from "react";
import Footer from "../../../MyComponents/Footer";
import GuestNav from "../../../MyComponents/Navbars/GuestNav";
import Hero2 from "../../../MyComponents/Hero2";
import heroContent from "../HeroContent";
import leftimg from "../../../assets/astronomyLeft.png";
import rightimg from "../../../assets/astronomyRight.png";
import CourseTimeline from "../../../MyComponents/CourseTimeline";
import Benefits from "../../../MyComponents/Benefits";
import astronomyBenefitsImg1 from "../../../assets/astronomyBenefitsImg1.png";
import astronomyBenefitsImg2 from "../../../assets/astronomyBenefitsImg2.png";
import astronomyBenefitsImg3 from "../../../assets/astronomyBenefitsImg3.png";
import astronomyBenefitsImg4 from "../../../assets/astronomyBenefitsImg4.png";
import astronomyBenefitsImg5 from "../../../assets/astronomyBenefitsImg5.png";
import astronomyBenefitsImg6 from "../../../assets/astronomyBenefitsImg6.png";
import astronomyBenefitsImg7 from "../../../assets/astronomyBenefitsImg7.png";
import astronomyBenefitsImg8 from "../../../assets/astronomyBenefitsImg8.png";
import astronomyBenefitsImg9 from "../../../assets/astronomyBenefitsImg9.png";
import FunActivities from "../../../MyComponents/FunActivities";
import astronomyFunActivitiesImg1 from "../../../assets/AstronomyFunActivitiesImg1.png";
import astronomyFunActivitiesImg2 from "../../../assets/AstronomyFunActivitiesImg2.png";
import astronomyFunActivitiesImg3 from "../../../assets/AstronomyFunActivitiesImg3.png";
import astronomyFunActivitiesImg4 from "../../../assets/AstronomyFunActivitiesImg4.png";
import astronomyFunActivitiesImg5 from "../../../assets/AstronomyFunActivitiesImg5.png";
import LearningStyle from "../../../MyComponents/LearningStyle";
import VideoSection from "../../../MyComponents/VideoSection";
import Testimonials from "../../../MyComponents/Testimonials";
import FAQs from "../../../MyComponents/FooterPages/newfaq";

const AstronomyPortal = () => {
  const astronomyPage = heroContent.astronomyPage;

  const foundationModules = [
    {
      title: "Module 1",
      activities: "03",
      classes: "02",
      description:
        "Structures - Understand structural forces by building a bridge with ice cream sticks.",
    },
    {
      title: "Module 2",
      activities: "03",
      classes: "02",
      description:
        "AutoCAD - Learn basic house planning using AutoCAD software.",
    },
    {
      title: "Module 3",
      activities: "04",
      classes: "03",
      description:
        "Construction Equipment - Explore tools and machines used in construction projects.",
    },
    {
      title: "Module 4",
      activities: "03",
      classes: "02",
      description:
        "Construction Management - Learn how to manage construction processes and phases.",
    },
  ];

  const beginnerModules = [
    {
      title: "Module 1",
      activities: "04",
      classes: "03",
      description:
        "Structures - Learn about structural forces using ETABS software to visualize stress points.",
    },
    {
      title: "Module 2",
      activities: "04",
      classes: "03",
      description: "AutoCAD - Create medium-level house plans using AutoCAD.",
    },
    {
      title: "Module 3",
      activities: "04",
      classes: "03",
      description:
        "Construction Equipment - Explore machinery used in small and large construction projects.",
    },
    {
      title: "Module 4",
      activities: "04",
      classes: "03",
      description:
        "Construction Management - Learn construction processes and use Primavera P6 to schedule a house project.",
    },
  ];

  const advancedModules = [
    {
      title: "Module 1",
      activities: "04",
      classes: "03",
      description:
        "Structures - Explore structural forces using ETABS and understand their effects on buildings.",
    },
    {
      title: "Module 2",
      activities: "04",
      classes: "03",
      description:
        "AutoCAD - Design advanced house plans and get introduced to 3D modeling in AutoCAD.",
    },
    {
      title: "Module 3",
      activities: "04",
      classes: "03",
      description:
        "Construction Equipment - Learn about construction machinery and different types of construction projects.",
    },
    {
      title: "Module 4",
      activities: "04",
      classes: "03",
      description:
        "Construction Management - Understand construction processes and use Primavera P6 to plan a large-scale project.",
    },
  ];

  const benefitsData = [
    {
      title: "Learn Astronomy History",
      description: "Discover ancient and modern space discoveries.",
      icon: astronomyBenefitsImg1,
    },
    {
      title: "Explore The Solar System",
      description: "Know planets, moons, and space objects.",
      icon: astronomyBenefitsImg2,
    },
    {
      title: "Understand Earth",
      description: "Learn about Earth's rotation, atmosphere, and seasons.",
      icon: astronomyBenefitsImg3,
    },
    {
      title: "Use An Astrolabe",
      description: "Try a classic tool to track stars.",
      icon: astronomyBenefitsImg4,
    },
    {
      title: "Know Constellations",
      description: "Identify patterns in the night sky.",
      icon: astronomyBenefitsImg5,
    },
    {
      title: "Use A Planisphere",
      description: "Find stars easily with a rotating chart.",
      icon: astronomyBenefitsImg6,
    },
    {
      title: "Study Space Rocks",
      description: "Explore asteroids, comets, and meteorites.",
      icon: astronomyBenefitsImg7,
    },
    {
      title: "Build A Telescope",
      description: "Learn and create your own telescope.",
      icon: astronomyBenefitsImg8,
    },
    {
      title: "Fun And Engaging Format",
      description:
        "Keeps kids excited with videos, visuals, and interactive lessons.",
      icon: astronomyBenefitsImg9,
    },
  ];
  const activitiesData = [
    {
      title: "Astrolabe",
      image: astronomyFunActivitiesImg1,
    },
    {
      title: "Make a Telescope",
      image: astronomyFunActivitiesImg2,
    },
    {
      title: "Plainisphere",
      image: astronomyFunActivitiesImg3,
    },
    {
      title: "Stellarium Software",
      image: astronomyFunActivitiesImg4,
    },
    {
      title: "Sky Gazing",
      image: astronomyFunActivitiesImg5,
    },
  ];

  const videoData = {
    title: "Watch Our Introduction Video",
    description:
      "Discover how our Brain Train Abacus Course can enhance your child's cognitive skills, memory, and concentration! Our video walks you through the exciting features of the course, the benefits of learning abacus, and how it can unlock your child's full potential.\n\nClick play and learn how we make learning fun, engaging, and effective for young minds.",
    videoSrc: "", // Replace with the actual video URL
  };

  return (
    <>
      <GuestNav />
      <Hero2
        titlePart1={astronomyPage.titlePart1}
        titlePart2={astronomyPage.titlePart2}
        description={astronomyPage.description}
        buttonText={astronomyPage.buttonText}
        leftImage={leftimg}
        rightImage={rightimg}
      />
      <CourseTimeline
        title1="Course Structure & Syllabus"
        title="Beginner Level Course"
        modules={foundationModules}
      />
      <CourseTimeline
        title="Intermediate Level Course"
        modules={beginnerModules}
      />
      <CourseTimeline title="Advance Level Course" modules={advancedModules} />
      <Benefits
        title="How Students Can Benefit From Astronomy Course"
        benefitsData={benefitsData}
      />
      <FunActivities
        mainTitle="Learn Astronomy"
        subTitle="With 40+ Fun Activities"
        activities={activitiesData}
      />
      <LearningStyle />
      <VideoSection
        title={videoData.title}
        description={videoData.description}
        videoSrc={videoData.videoSrc}
      />
      <Testimonials />
      <FAQs />
      <Footer />
    </>
  );
};
export default AstronomyPortal;
